<template>
  <!-- can-cancel = ['escape', 'x', 'outside'] si se quiere que cierre  por cualqiera de esos [] caso contrario -->
  <b-modal :active.sync="isModalActive" :width="680" scroll="keep" :can-cancel="[]">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg bg-white overflow-hidden border border-[#E4E6EB] shadow-lg">
      <!-- HEADER estilo Meta -->
      <header class="flex justify-between items-center px-4 py-3 border-b border-[#E4E6EB] bg-white">
        <div class="flex-1 min-w-0">
          <h2 class="text-base font-semibold text-gray-900 break-words whitespace-normal">
            {{ $t('save_pictogram_title') }}
          </h2>
        </div>
        <button
          v-if="!processingData"
          @click="hide()"
          class="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-1"
          aria-label="Cerrar"
        >
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        </button>
      </header>

      <!-- CONTENIDO -->
      <div class="px-4 py-4 space-y-4 bg-white">

        <!-- Nombre del pictograma (requerido) -->
        <b-field :label="$t('name')"
          :type="{ 'is-danger': errors.name }"
          :message="errors.name ? $t('field_required') : ''">
          <b-input v-model="form.name"
            :disabled="processingData"
            size="is-small"
            maxlength="100"
            @input="errors.name = false" />
        </b-field>

        <!-- Código (opcional) -->
        <b-field :label="$t('code')">
          <b-input v-model="form.code"
            :disabled="processingData"
            size="is-small"
            maxlength="20" />
        </b-field>

      </div>

      <!-- FOOTER estilo Meta -->
      <footer class="px-4 py-3 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex items-center gap-2" :class="processingData ? 'justify-center' : 'justify-between'">
          <v-button v-if="!processingData" color="grey" icon="door-closed" size="is-small" @click="hide()">{{ $t('close') }}</v-button>
          <v-button v-if="!processingData" @click="handleClick()" icon="check" size="is-small">
            {{ $t('accept') }}
          </v-button>
          <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'SavePictogramModal',
  data() {
    return {
      isModalActive: false,
      isLoading: false,
      processingData: false,
      form:   { name: '', code: '' },
      errors: { name: false },
    }
  },

  methods: {
    /**
     * Abre el modal en limpio. Resetea form, errores y estado de proceso.
     */
    show() {
      this.form           = { name: '', code: '' }
      this.errors         = { name: false }
      this.processingData = false
      this.isModalActive  = true
    },

    hide() {
      this.isModalActive = false
    },

    /**
     * Valida el nombre y emite la configuración al padre. El padre se encarga del upload.
     */
    handleClick() {
      const name = this.form.name.trim()
      if (!name) {
        this.errors.name = true
        this.$toast.open({
          message:  this.$t('field_required'),
          type:     'is-danger',
          position: 'is-top-right',
        })
        return
      }
      this.$emit('epc-apply', { name, code: this.form.code.trim() || null })
      this.hide()
    },
  }
}
</script>

<style scoped>

</style>
